module.exports = __webpack_public_path__ + "static/media/400021_02.3f557a4b.png";